function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var UserMenu = require('./../../lib/saito/ui/modals/user-menu/user-menu');
var HeaderDropdownTemplate = function HeaderDropdownTemplate(dropdownmods) {
  html = dropdownmods.map(function (mod) {
    if (mod.returnLink() != null) {
      return "<a href=\"".concat(mod.returnLink(), "\"><li>").concat(mod.name, "</li></a>");
    }
  });
  return "\n  <div id=\"modules-dropdown\" class=\"header-dropdown\">\n    <ul>".concat(html, "</ul>\n  </div>");
};
var QRScanner = /*#__PURE__*/function (_ModTemplate) {
  function QRScanner(app) {
    var _this;
    _classCallCheck(this, QRScanner);
    _this = _callSuper(this, QRScanner, [app]);
    _this.name = 'QRScanner';
    _this.slug = 'qrscanner';
    _this.description = 'Adds QRCode scanning functionality to Saito';
    _this.categories = 'Core';
    _this.video = null;
    _this.canvas = null;
    _this.canvas_context = null;
    _this.isStreamInit = false;
    _this.styles = ['/qrscanner/style.css'];
    _this.scanner_callback = null;
    _this.dependencies = ['Encrypt']; // For scan to add encrypted contact
    _this.description = 'Helper module with QR code scanning functionality.';
    _this.categories = 'Dev Data Utilities';
    _this["class"] = 'utility';
    _this.constraints = {
      audio: false,
      video: {
        facingMode: 'environment'
      }
    };

    // quirc wasm version
    _this.decoder = null;
    _this.decoder_timeout = null;
    _this.scan_session = 0;
    _this.last_scanned_raw = null;
    _this.last_scanned_at = null;

    // In milliseconds
    _this.debounce_timeout = 750;
    _this.events = ['encrypt-key-exchange-confirm'];

    //
    // and scan when asked
    //
    _this.app.connection.on('scanner-start-scanner', function () {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      _this.startScanner(callback);
    });
    return _this;
  }
  _inherits(QRScanner, _ModTemplate);
  return _createClass(QRScanner, [{
    key: "initialize",
    value: function initialize(app) {
      _superPropGet(QRScanner, "initialize", this, 3)([app]);
      if (app.BROWSER == 1) {
        this.attachStyleSheets();
      }
    }
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (type === 'saito-header') {
        var mobileViewport = typeof window !== 'undefined' && window.innerWidth <= 620;
        if (this.app.browser.isMobileBrowser() || mobileViewport) {
          return [{
            text: 'Scan',
            icon: 'fa-solid fa-qrcode',
            rank: 110,
            type: 'utilities',
            callback: function callback(app) {
              app.connection.emit('scanner-start-scanner');
            }
          }];
        }
      }
      return _superPropGet(QRScanner, "respondTo", this, 3)([type]);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(app) {
      var _document$querySelect;
      var scanner_self = this;
      (_document$querySelect = document.querySelector('.qrscanner-launch')) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('click', function (e) {
        scanner_self.startScanner();
      });
    }
  }, {
    key: "startQRDecoderInitializationLoop",
    value: function startQRDecoderInitializationLoop(scanSession) {
      var _this2 = this;
      if (scanSession !== this.scan_session || !this.decoder) {
        return;
      }
      var decoderStarted = this.attemptQRDecode();
      if (decoderStarted !== 1) {
        this.decoder_timeout = setTimeout(function () {
          _this2.decoder_timeout = null;
          _this2.startQRDecoderInitializationLoop(scanSession);
        }, 100);
      }
    }

    //
    // turns BODY into the scanner
    //
  }, {
    key: "startScanner",
    value: function startScanner() {
      var _this3 = this;
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.app.BROWSER == 0) {
        return;
      }
      if (typeof document === 'undefined') {
        return;
      }
      if (document.querySelector('.qrscanner-container')) {
        return;
      }
      if (mycallback != null) {
        this.scanner_callback = mycallback;
      }
      this.app.browser.addElementToDom(this.returnScannerHTML());
      //document.body.innerHTML = this.returnScannerHTML();
      document.querySelector('.close-scanner').onclick = function () {
        document.querySelector('.qrscanner-container').remove();
        _this3.stop();
      };
      var scanner_self = this;
      scanner_self.start(document.getElementById('qr-video'), document.getElementById('qr-canvas'));
    }

    //
    // turns submitted EL into the scanner
    //
  }, {
    key: "startEmbeddedScanner",
    value: function startEmbeddedScanner(el) {
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (this.app.BROWSER == 0) {
        return;
      }
      if (typeof document === 'undefined') {
        return;
      }
      if (document.querySelector('.qrscanner-container')) {
        return;
      }
      if (mycallback != null) {
        this.scanner_callback = mycallback;
      }
      el.innerHTML = this.returnScannerHTML();
      document.querySelector('.close-scanner').onclick = function () {
        reloadWindow(300);
      };
      var scanner_self = this;
      scanner_self.start(document.getElementById('qr-video'), document.getElementById('qr-canvas'));
    }
  }, {
    key: "returnScannerHTML",
    value: function returnScannerHTML() {
      return "\n      <div class=\"qrscanner-container\">\n        <div id=\"qr-target\" class=\"qr-target\">\n          <div class=\"corners\"></div>\n          <div id=\"scanline\" class=\"scanline\"></div>\n        </div>\n        <div id=\"close-scanner\" class=\"close-scanner\"><i class=\"fa-solid fa-xmark\"></i></div>\n        <div class=\"qr-video-container\">\n          <video playsinline autoplay id=\"qr-video\" class=\"qr-video\"></video>\n        </div>\n        <canvas style=\"display: none\" id=\"qr-canvas\"></canvas>\n      </div>\n\n    ";
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(video, canvas) {
        var _this4 = this;
        var scanSession, stream, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              scanSession = ++this.scan_session;
              this.video = video;
              this.canvas = canvas;
              _context.p = 1;
              this.canvas_context = this.canvas.getContext('2d');
              this.decoder = new Worker('/qrscanner/quirc_worker.js');
              this.decoder.onmessage = function (msg) {
                if (scanSession === _this4.scan_session) {
                  _this4.onDecoderMessage(msg, scanSession);
                }
              };
              _context.n = 2;
              return navigator.mediaDevices.getUserMedia(this.constraints);
            case 2:
              stream = _context.v;
              if (!(scanSession !== this.scan_session)) {
                _context.n = 3;
                break;
              }
              stream.getTracks().forEach(function (track) {
                return track.stop();
              });
              return _context.a(2);
            case 3:
              this.handleSuccess(stream);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              if (scanSession === this.scan_session) {
                this.handleError(_t);
              }
              return _context.a(2);
            case 5:
              this.startQRDecoderInitializationLoop(scanSession);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4]]);
      }));
      function start(_x, _x2) {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      var _this$decoder, _this$video;
      this.scan_session++;
      if (this.decoder_timeout) {
        clearTimeout(this.decoder_timeout);
        this.decoder_timeout = null;
      }
      (_this$decoder = this.decoder) === null || _this$decoder === void 0 || _this$decoder.terminate();
      this.decoder = null;
      if ((_this$video = this.video) !== null && _this$video !== void 0 && _this$video.srcObject) {
        this.video.srcObject.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
      this.isStreamInit = false;
      this.scanner_callback = null;
      if (typeof document !== 'undefined' && document.querySelector('.qrscanner-container')) {
        document.querySelector('.qrscanner-container').remove();
      }
    }
  }, {
    key: "render",
    value: function render() {}

    //
    // main loop sending messages to quirc_worker to detect qrcodes on the page
    //
  }, {
    key: "attemptQRDecode",
    value: function attemptQRDecode() {
      if (this.isStreamInit) {
        try {
          this.canvas.width = this.video.videoWidth;
          this.canvas.height = this.video.videoHeight;
          this.canvas_context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
          if (this.canvas.width == 0) return;
          var imgData = this.canvas_context.getImageData(0, 0, this.canvas.width, this.canvas.height);
          if (imgData.data) {
            this.decoder.postMessage(imgData);
          }
          return 1;
        } catch (err) {
          return 0;
        }
      } else {
        return 0;
      }
      return 0;
    }

    //
    // worker passes back a message either containing decoded data,
    // or it attempts t
    //
  }, {
    key: "onDecoderMessage",
    value: function onDecoderMessage(msg) {
      var _this5 = this;
      var scanSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scan_session;
      if (scanSession !== this.scan_session) {
        return;
      }
      if (msg.data != 'done') {
        var qrid = msg.data['payload_string'];
        var right_now = Date.now();
        if (qrid != this.last_scanned_raw || this.last_scanned_at < right_now - this.debounce_timeout) {
          this.last_scanned_raw = qrid;
          this.last_scanned_at = right_now;
          this.handleDecodedMessage(qrid);
          return;
        } else if (qrid === this.last_scanned_raw) {
          this.last_scanned_at = right_now;
        }
      }
      this.decoder_timeout = setTimeout(function () {
        _this5.decoder_timeout = null;
        if (scanSession === _this5.scan_session) {
          _this5.attemptQRDecode();
        }
      }, 0);
    }

    //
    // The default behavior of just a publickey is to created initiate a keyexchange.
    // Else, the message is broadcast for other modules to utilize
    //
  }, {
    key: "handleDecodedMessage",
    value: function handleDecodedMessage(msg) {
      //
      // remove scanline
      //
      if (document.querySelector('.scanline')) {
        document.querySelector('.scanline').remove();
      }

      //
      // we know what we want to do (callback provided)
      //
      if (this.scanner_callback != null) {
        var callback = this.scanner_callback;
        this.stop();
        callback(msg);
        return;
      }
      var decodedValue = typeof msg === 'string' ? msg.trim() : msg;

      //
      // or this is a URL
      //
      if (this.app.browser.isValidUrl(decodedValue)) {
        this.stop();
        var c = confirm('Visit: ' + decodedValue + '?');
        if (c) {
          navigateWindow(decodedValue);
          return;
        }
      }

      //
      // or this is a publickey
      //
      if (this.app.crypto.isPublicKey(decodedValue)) {
        this.stop();
        this.openUserMenu(decodedValue);
        return;
      }

      //
      // non-SAITO publickey?
      //
      if (typeof decodedValue === 'string' && !decodedValue.match(/\s/gi)) {
        if (decodedValue.match(/[0-9a-zA-Z]+/i)) {
          this.stop();
          var obj = {};
          obj.address = decodedValue;
          this.app.connection.emit('saito-crypto-withdraw-render-request', obj);
          return;
        }
      }
      this.sendEvent('qrcode', msg);
    }
  }, {
    key: "openUserMenu",
    value: function openUserMenu(publicKey) {
      var userMenu = new UserMenu(this.app, publicKey);
      void userMenu.render();
    }
  }, {
    key: "decodeFromFile",
    value: function decodeFromFile(f) {
      var _this6 = this;
      var reader = new FileReader();
      reader.onload = function (file) {
        return function (e) {
          _this6.canvas_context.clearRect(0, 0, _this6.canvas.width, _this6.canvas.height);
          // port to new quirc system
        };
      }(f);
      reader.readAsDataURL(f);
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(stream) {
      window.stream = stream;
      this.video.srcObject = stream;
      this.isStreamInit = true;
    }
  }, {
    key: "handleError",
    value: function handleError(error) {
      console.error('QRScanner: unable to start camera', error);
      this.stop();
      if (typeof siteMessage === 'function') {
        siteMessage("Unable to access the camera. Check this site's camera permission.", 4000);
      }
    }
  }]);
}(ModTemplate);
module.exports = QRScanner;